import { useLocation } from "react-router-dom";

const breadcrumbMap = {
  auditReport: "Audit Report",
  auditBrowser: "Audit Browser",
  reportbrowser: "Section Browser",
  storebrowser: "Store Browser",
  storeBrowserInsights: "Insights",
  "store-performance": "Store Performance",
  "net-promoter-score": "NPS",
};

const BreadCrumbLayout = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((path) => path);

  return (
    <span className="breadcrumb-inline">
      {pathnames.map((path, index) => {
        const displayName = breadcrumbMap[path] || path.replace(/-/g, " ");

        return (
          <span key={index}>
            {" / "}
            <span>{displayName}</span>
          </span>
        );
      })}
    </span>
  );
};

export default BreadCrumbLayout;
